export default "__VITE_ASSET__BMqdgmmD__"